import type { WeightChangeEntry } from '../store/useTerminalStore';

interface SwapLogProps {
  history: WeightChangeEntry[];
  className?: string;
}

function formatTime(ts: number): string {
  const d = new Date(ts);
  return d.toLocaleTimeString('en-US', { hour12: false, hour: '2-digit', minute: '2-digit', second: '2-digit' });
}

export function SwapLog({ history, className = '' }: SwapLogProps) {
  return (
    <div className={`bg-card rounded border border-border p-2 ${className}`}>
      <div className="drag-handle h-5 flex items-center cursor-grab active:cursor-grabbing mb-1">
        <span className="panel-header">SWAP LOG</span>
        <span className="ml-auto text-[8px] font-mono text-muted">{history.length}</span>
      </div>
      {history.length === 0 ? (
        <div className="flex items-center justify-center h-[calc(100%-24px)]">
          <span className="text-[9px] font-mono text-muted">No weight changes</span>
        </div>
      ) : (
        <div className="overflow-auto h-[calc(100%-24px)]">
          <table className="w-full text-[9px] font-mono">
            <thead>
              <tr className="text-muted-foreground text-left uppercase">
                <th className="pb-1 pr-2">Time</th>
                <th className="pb-1 pr-2">Combo</th>
                <th className="pb-1 text-right">Weight</th>
              </tr>
            </thead>
            <tbody>
              {history.map((entry, i) => (
                <tr key={`${entry.combo}-${entry.timestamp}-${i}`} className="border-t border-border-subtle">
                  <td className="py-0.5 pr-2 text-muted">{formatTime(entry.timestamp)}</td>
                  <td className="py-0.5 pr-2 text-primary">{entry.combo}</td>
                  <td className="py-0.5 text-right text-foreground">{(entry.weight * 100).toFixed(1)}%</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
